"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var idbstorage_1 = require("@wora/cache-persist/lib/idbstorage");
var relay_store_1 = require("@wora/relay-store");
var Environment_1 = require("./Environment");
var EnvironmentIDB = (function () {
    function EnvironmentIDB() {
    }
    EnvironmentIDB.create = function (config, idbOptions, recordSourceOptions, storeOptions, offlineStoreOptions) {
        if (idbOptions === void 0) { idbOptions = {}; }
        if (recordSourceOptions === void 0) { recordSourceOptions = {}; }
        if (storeOptions === void 0) { storeOptions = {}; }
        if (offlineStoreOptions === void 0) { offlineStoreOptions = {}; }
        var options = storeOptions.options, persistOptions = storeOptions.persistOptions;
        var idbStore = tslib_1.__assign({ serialize: false, prefix: null }, persistOptions);
        var idbRecords = tslib_1.__assign({ serialize: false, prefix: null }, recordSourceOptions);
        var idbOffline = tslib_1.__assign({ serialize: false, prefix: null }, offlineStoreOptions);
        if (typeof window !== 'undefined') {
            var _a = idbOptions.name, name_1 = _a === void 0 ? 'relay' : _a, onUpgrade = idbOptions.onUpgrade, version = idbOptions.version;
            var idbStorages = idbstorage_1.IDBStorage.create({
                name: name_1,
                storeNames: ['store', 'records', 'offline'],
                onUpgrade: onUpgrade,
                version: version,
            });
            idbStore.storage = idbStorages[0];
            idbRecords.storage = idbStorages[1];
            idbOffline.storage = idbStorages[2];
        }
        var recordSource = new relay_store_1.RecordSource(idbRecords);
        var store = new relay_store_1.Store(recordSource, idbStore, options);
        return new Environment_1.Environment(tslib_1.__assign(tslib_1.__assign({}, config), { store: store }), idbOffline);
    };
    return EnvironmentIDB;
}());
exports.default = EnvironmentIDB;
//# sourceMappingURL=EnvironmentIDB.js.map